import Vector2d from '../engine/vector2d';
import Entity from '../entity';
import State from '../state';
import { ChaseMode, Ghost } from './ghost';

export default class Clyde extends Ghost {

  getSpriteOffset(): number {
    return 3;
  }

  getGhost(state: State): Entity {
    const [clyde] = state.ghosts.filter(g => g.name === 'clyde');
    return clyde;
  }

  getTarget(mode: ChaseMode, state: State): Vector2d {
    switch (mode) {
      case ChaseMode.Chase:
      case ChaseMode.Frightened:
        return this.getClosestTarget(state);
    }

    return this.getGhost(state).position;
  }
}
